import type { IFieldDefinition, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Поле виду запису: поле-вибір, від значення якого залежать інші поля типу (`visibleWhen.field`; бізнес-аналіз — «Тип запису»: функція,
 * проблема, вимога…), з кількома варіантами; інакше undefined. Такий тип створюють із вибором виду (прототип v4 baNewMenu). Чиста функція.
 */
export function kindFieldOf(rt: IRecordTypeDefinition): IFieldDefinition | undefined {
  const key = rt.fields.find((f) => f.visibleWhen?.field)?.visibleWhen?.field;
  const field = key ? rt.fields.find((f) => f.key === key) : undefined;
  return field?.type === 'select' && (field.options?.length ?? 0) > 1 ? field : undefined;
}
